// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3iuQb","footer":"Form_footer__2G_XQ"};